var exports = {
  "q": "AttachmentSingleMedia.module__relativeWrapper___ZVBHR3",
  "u": "AttachmentSingleMedia.module__singleMediaContainer___ZVBHR3",
};

module.exports = exports;
